export class SsqDataDocumentEntity {
  id: number = undefined;
  admission: string = '';
  badCount: number = undefined;
  clickCount: number = undefined;
  description: string = '';
  displayTarget: number = undefined;
  docTitle: string = '';
  docType: string = '';
  expose: boolean = false;
  exposeSiteLanguage: string = '';
  goodCount: number = undefined;
  imageUrl: string = '';
  lastModifierId: string = '';
  parentId: number = undefined;
  relatedProducts: string = '';
  searchExpose: boolean = false;
  updateTime: string = '';
  writerId: string = '';
  writerNickname: string = '';
  answerCnt: number = undefined;
  docPoint: number = undefined;
  docSampleSmry: string = '';
  employ: boolean = false;
  finished: boolean = false;
  qrtrDocPoint: number = undefined;
  reportedCnt: number = undefined;
  shareCount: number = undefined;
}

export interface IfSsqDataDocumentEntity extends SsqDataDocumentEntity {
}
